import React from 'react';
import { RouteComponentProps, Redirect, NavLink } from 'react-router-dom';
import Locale from 'localization/Localization';
import { PublicLayout } from 'components/public/PublicLayout';
import { SignupForm } from 'components/login/SignupForm';
import { AppServices } from 'services/AppServices';

interface SignupPageState {
	hasSession: boolean;
	signupDone: boolean;
}

export class SignupPage extends React.Component<RouteComponentProps<{}>, SignupPageState>
{
	constructor(props: RouteComponentProps<{}>) {
		super(props);

		const session = AppServices.loginService.getSession();

		this.state = {
			hasSession: session !== undefined,
			signupDone: false
		};
	}

	public componentDidMount() {
		document.title = Locale.getPageTitle('page_signup');
	}

	public render() {
		if (this.state.hasSession)
			return <Redirect to={'/login'} />

		if (this.state.signupDone)
			return <>
				<PublicLayout>
					<div className='login-container'>
						<h2>{Locale.get('signup_completedHeader')}</h2>
						<p>{Locale.get('signup_completedBody')}</p>
						<NavLink to='/login'>{Locale.get('signup_linkToLogin')}</NavLink>
					</div>
				</PublicLayout>
			</>

		return <>
			<PublicLayout>
				<SignupForm onSuccessFn={() => { this.setState({ signupDone: true }) }} />
			</PublicLayout>
		</>
	}
}